import React from "react";

const CheckBoxChecked = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="4" fill="#0252A7" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.727 7.275a.857.857 0 0 1 0 1.212l-8.09 8.125a.857.857 0 0 1-1.212 0l-4.044-4.063a.857.857 0 0 1 0-1.212.857.857 0 0 1 1.212 0l3.384 3.4 7.43-7.462a.857.857 0 0 1 1.212 0Z"
        fill="white"
      />
    </svg>
  );
};

export default CheckBoxChecked;
